import React, { useState, useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import Img1 from "../assets/1.jpg";
import Img2 from "../assets/2.jpg";
import Img3 from "../assets/3.jpg";
import Img4 from "../assets/4.jpg";
import Img5 from "../assets/5.jpg";

const Gallery = ({ t }) => {
  const images = [
    { id: 0, url: Img1, size: "tall" },
    { id: 1, url: Img2, size: "wide" },
    { id: 2, url: Img3, size: "small" },
    { id: 3, url: Img4, size: "tall" },
    { id: 4, url: Img5, size: "small" },
    { id: 5, url: Img1, size: "wide" },
  ];

  const [selectedImg, setSelectedImg] = useState(null);

  const showNext = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      setSelectedImg((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    },
    [images.length],
  );

  const showPrev = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      setSelectedImg((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    },
    [images.length],
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImg === null) return;
      if (e.key === "Escape") setSelectedImg(null);
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImg, showNext, showPrev]);

  // Ako t nije proslijeđen, ne renderaj ništa (da izbjegnemo crash)
  if (!t) return null;

  return (
    <section className="gallery-section" id="gallery">
      <div className="container">
        <div className="gallery-header">
          <h2 className="script-font">{t.galleryTitle}</h2>
        </div>

        <div className="gallery-grid">
          {images.map((img, index) => (
            <div
              key={img.id}
              className={`gallery-item ${img.size}`}
              onClick={() => setSelectedImg(index)}
            >
              <div className="img-container">
                <img src={img.url} alt="Wedding" loading="lazy" />
                <div className="img-overlay">
                  <span className="serif-font">{t.galleryViewBtn}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImg !== null && (
        <div className="gallery-modal" onClick={() => setSelectedImg(null)}>
          <button className="close-btn" onClick={() => setSelectedImg(null)}>
            <X size={30} />
          </button>

          <button className="nav-arrow left" onClick={showPrev}>
            <ChevronLeft size={30} strokeWidth={1.5} />
          </button>

          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={images[selectedImg].url}
              alt="Full view"
              className="fade-in"
            />
          </div>

          <button className="nav-arrow right" onClick={showNext}>
            <ChevronRight size={30} strokeWidth={1.5} />
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
